import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UserResponse } from '../../models/account/userResponse';
import { AuthService } from '../../services/account/auth.service';
import { CommonModule, DatePipe } from '@angular/common';
import { Gender, GenderDescriptions, ProfileSection } from '../../models/enums/enums';
import { ProfileSectionComponent } from "./profile-section/profile-section.component";
import { EssayPilotSectionComponent } from "./essay-pilot-section/essay-pilot-section.component";
import { CheckListSectionComponent } from './check-list-section/check-list-section.component';
import { TestScoreResponse } from '../../models/account/test-score/testScoreResponse';
import { countryResponse } from '../../models/country/countryResponse';
import { forkJoin } from 'rxjs';
import { UtilityService } from '../../services/utility/utility.service';
import { Activity } from '../../models/account/extra-curricular/activity/activityResponse';
import { StudentDocumentResponse } from '../../models/document/studentDocumentResponse';
import { DialogModule } from 'primeng/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdditionalInformationService } from '../../services/additional-information/additional-information.service';
import { UserStateModel } from '../../states/user/user-state-model';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../states/user/user-selector';
import { AdditionalInformation } from '../../models/enums/additionalInformation';
import { AdditionalInformationResponse } from '../../models/account/additional-information/additionalInformationResponse';
import { CalendarModule } from 'primeng/calendar';
import { GeneralTasksComponent } from "./general-tasks/general-tasks.component";
import { DownloadProfileService } from '../../services/download/download-profile.service';
import { FileSelectEvent, FileUpload, FileUploadModule } from 'primeng/fileupload';
import { FileUploaderComponent } from "../../utility/file-uploader/file-uploader.component";
import { ColorPickerModule } from 'primeng/colorpicker';
import { CollegesSectionComponent } from './colleges-section/colleges-section.component';

import { TabViewModule } from 'primeng/tabview';
import { OperationsStudentDocumentVaultComponent } from '../../operations-portal/student/student-details/document-vault/document-vault.component';

@Component({
  selector: 'app-applicant-profile',
  standalone: true,
  imports: [ButtonModule, CommonModule, DialogModule, AutoCompleteModule,
    FormsModule, InputTextareaModule, DropdownModule, InputTextModule, CheckboxModule,
    MessagesModule, ProgressSpinnerModule, RouterModule, ProfileSectionComponent,
    EssayPilotSectionComponent, CheckListSectionComponent,
    ReactiveFormsModule, CalendarModule, GeneralTasksComponent, FileUploadModule,
    CollegesSectionComponent, TabViewModule, OperationsStudentDocumentVaultComponent],
  templateUrl: './applicant-profile.component.html',
  styleUrl: './applicant-profile.component.scss',
  providers: [DatePipe]
})

export class ApplicantProfileComponent implements OnInit {
  activeTab: number = 0;

  visible: boolean = false;

    showDialog() {
        this.visible = true;
    }
    // showAddClgDialog(){
    //   this.addClgVisible = true
    // }
  @ViewChild('fileUploader') fileUploader!: FileUpload;
  @ViewChild(GeneralTasksComponent) generalTasksComponent!: GeneralTasksComponent;
  userId: string = '';
  user: UserResponse | null | undefined;
  testScore: TestScoreResponse | null | undefined;
  profileSection = ProfileSection;
  currentProfileSection: string = ProfileSection.Profile;
  currentAdditionalInfoSection = AdditionalInformation.Profile;
  countries: countryResponse[] = [];
  activities: Activity[] | null | undefined;
  documents: StudentDocumentResponse[] = [];
  recentResolvedQuestion: AdditionalInformationResponse | undefined;
  attachment: File | Blob | undefined;
  uploadedImageUrl: string | null | undefined;

  // visible:boolean = false;
  additionalInformationForm!: FormGroup;
  submitted: boolean = false;
  isLoading: boolean = false;
  mentor!: UserStateModel;
  // addClgVisible: boolean  = false;

  time: Date[] | undefined;
  brandColors: string[] = ['#000086', '#CDD12A', '#12263F', '#6766B6', '#B1C2D9'];
  selectedColor: string = '';

  initializeForm(){
    this.additionalInformationForm = this.formBuilder.group({
      additionalInfo: ['', Validators.required],
      dueDate: [null, Validators.required],
      startDate: [null, Validators.required],
      color: ['']
    });
  }

  constructor( private route: ActivatedRoute,
    private store: Store,
    private authService: AuthService,
    private additionalInformationService: AdditionalInformationService,
    private utilityService: UtilityService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private downloadProfileService: DownloadProfileService,
    private cdr: ChangeDetectorRef
  ){ }

  showAdditionalInformationDialog(){
    this.resetFormState();
    this.getRecentAdditionalInformationSubmission();
    this.visible = true;
  }
  closeDialog(){
    this.visible = false;
  }

  downloadProfileAsPDF(){
    this.downloadProfileService.downloadStudentProdileAsPdf(this.userId).subscribe({
      next: (response) => {
        // const cd = response.headers.get('Content-Disposition');
        const filename = 'student-profile.pdf';
        // const filename = this.getFilenameFromContentDisposition(cd) || 'student-profile.pdf';
        const blob = new Blob([response.body!], {type:'application/pdf'});
        this.saveBlobAsFile(blob, filename);
      }
    })
  }
  saveBlobAsFile(blob: Blob | null, filename: string): void {
    if (blob) {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  }


  onAdditionalInformaionSubmit() {
    this.submitted = true;
    if (this.additionalInformationForm.invalid) {
      return;
    }
    this.isLoading = true;

    const formValue = this.additionalInformationForm.value;
    const selectedEndDate: Date = formValue.dueDate;
    const selectedStartDate: Date = formValue.startDate;

    const processRequest = (attachmentBase64: string | null) => {
      this.additionalInformationService.postAdditionalQuestion({
        studentId: this.userId,
        mentorId: this.mentor.id,
        type: this.currentAdditionalInfoSection,
        colourCode: formValue.color,
        question: formValue.additionalInfo,
        dueDate: selectedEndDate,
        startDate: selectedStartDate,
        requestedAttachment: attachmentBase64
      }).subscribe({
        next: () => {
          this.isLoading = false;
          this.additionalInformationForm.reset();
          this.attachment = undefined;
          this.selectedColor = '';
          this.closeDialog();
          this.additionalInformationService.triggerLoadData();
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Task Information updated successfully!"
          });
          // Update calendar if available
          if (this.generalTasksComponent) {
            this.generalTasksComponent.refreshCalendar();
          }
        },
        error: (err) => {
          console.warn(`error while retriving Task Information:${err}`);
          this.isLoading = false;
        }
      });
    };

    if (this.attachment) {
      this.convertBlobToBase64(this.attachment).then((result) => {
        processRequest(result);
      }).catch(() => {
        this.isLoading = false;
      });
    } else {
      processRequest(null);
    }
  }


  getRecentAdditionalInformationSubmission(){
    this.additionalInformationService.getRecentAdditionalInformation({
      studentId: this.userId,
      mentorId: this.mentor.id,
      type: this.currentAdditionalInfoSection
    }).subscribe({
      next:(response) =>{
        this.recentResolvedQuestion = response;
      },
      error: (err) =>{
        console.warn(`Error While Retriving Recent Task Information:${err}`);
      }
    })
  }

  // Update the onDialogClose method to handle all cleanups
  onDialogClose() {
    this.resetFormState();
  }

  // Create a centralized reset function
  resetFormState() {
    // Reset the Boolean submission flag
    this.submitted = false;

    // Reset the Reactive Form
    if (this.additionalInformationForm) {
      this.additionalInformationForm.reset();
    }

    // Clear local image/file variables
    this.attachment = undefined;
    this.uploadedImageUrl = null;
    this.selectedColor = '';

    // Clear the PrimeNG FileUpload UI component
    if (this.fileUploader) {
      this.fileUploader.clear();
    }

    // Manually trigger change detection to ensure the UI updates immediately
    this.cdr.detectChanges();
  }

  genderDescriptions(arg0: Gender | undefined): string {
    if (arg0) {
      return GenderDescriptions[arg0];
    }
    else {
      return '';
    }
  }

  getCountryName(arg0: string | null | undefined) {
    return this.countries.find(item => item.countryCode == arg0)?.name;
  }
  getCountries(arg0: string[] | undefined): string {
    if (!arg0) {
      return '';  // If arg0 is undefined or empty, return an empty string
    }

    const countryNames = arg0
      .map(item => {
        const country = this.countries.find(country => country.countryCode === item);
        return country ? country.name : undefined;  // Return country name or undefined
      })
      .filter(name => name !== undefined);  // Filter out any undefined values

    return countryNames.join(',');  // Join the country names with a comma
  }

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id') || '';
    this.getMentor();
    this.getUsersAfterDataLoaded();
    this.initializeForm();

  }

  getUsers(){
    this.authService.getUserByid(this.userId).subscribe({
      next:(response: any) => {
        // Try multiple unwrapping paths for different API response shapes
        const userData = response?.result ?? response?.responseData ?? response?.data ?? response;
        this.user = userData;
        console.log('[ApplicantProfile] user loaded:', this.user);
      },
      error: (err) => console.warn("Error Loading User: ", err),
    });
  }

  getMentor(){
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.mentor = response;
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }

  getUsersAfterDataLoaded() {
    forkJoin([
      this.utilityService.getCountries(),

    ]).subscribe({
      next: ([countriesResponse]) => {
        this.countries = countriesResponse.result;  // Set countries
        this.getUsers();
      },
      error: (err) => console.warn("Error loading data:", err),
    });
  }

  onFileSelection($event: import("ngx-awesome-uploader").FilePreviewModel[]) {
    if ($event.length > 0) {
      this.attachment = $event[0].file
    }
  }

  // onFileRemoved($event: import("ngx-awesome-uploader").FilePreviewModel[]) {
  //   if ($event.length > 0) {
  //     this.attachment = undefined;
  //   }
  // }
  onFileRemoved() {
    this.attachment = undefined;
    if (this.fileUploader) {
      this.fileUploader.clear();   // ✅ This clears the UI preview
    }
    this.cdr.detectChanges();      // Force UI refresh
  }

  onFileHandlingError(message: string) {
    if (message === 'FILE_MAX_SIZE')
      this.messageService.add({ severity: 'error', summary: 'FILE_MAX_SIZE', detail: `File size should be less than 20 MB` });
    else {
      this.messageService.add({ severity: 'error', summary: 'File Error', detail: message });
    }
  }

  convertBlobToBase64(file: File | Blob | undefined): Promise<string>{
    return new Promise((resolve, reject) => {
      if(!file){
        reject('No file provided');
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result as string)
      }
      reader.onerror = (error) => {
        reject('Error reading file: '+ error);
      }
    })
  }

  onFileSelect($event: FileSelectEvent): void {
    if ($event.files && $event.files.length > 0) {
      const filesArray = Array.from($event.files);
      let validFile: File | null = null;
      for (let i = filesArray.length - 1; i >= 0; i--) {
        if (filesArray[i].size > 1048576) { // 1 MB
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${filesArray[i].name} file size can't exceed 1 MB`
          });
        } else {
          validFile = filesArray[i];
        }
      }

      if (validFile) {
        this.attachment = validFile;

        //Preview the image
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.uploadedImageUrl = e.target.result;
        };
        reader.readAsDataURL(validFile);
      }

      //Clear file input so file can be reselected
      // setTimeout(() => {
      //   this.fileUploader.clear(); // clears PrimeNG UI
      // }, 0);
    }
  }

  onColorSelect(color: string): void {
    this.selectedColor = color;
    this.additionalInformationForm.get('color')?.setValue(color);
  }

  openSection(arg0: ProfileSection) {
    this.currentProfileSection = arg0.toString();

    switch (arg0) {
      case ProfileSection.Profile:
        this.currentAdditionalInfoSection = AdditionalInformation.Profile;
        break;
      case ProfileSection.CheckList:
        this.currentAdditionalInfoSection = AdditionalInformation.CheckList;
        break;
      case ProfileSection.EssayPilot:
        this.currentAdditionalInfoSection = AdditionalInformation.EssayPilot;
        break;
        case ProfileSection.General:
          this.currentAdditionalInfoSection = AdditionalInformation.General;
          break;
        case ProfileSection.Colleges:
          this.currentAdditionalInfoSection = AdditionalInformation.Profile;
          break;
      // Add other cases as needed
      default:
        this.currentAdditionalInfoSection = AdditionalInformation.Profile; // Default case
        break;
    }
  }
}
